// extracted by mini-css-extract-plugin
export default {"skillsbg":"Skills_skillsbg__+grhS","listtwo":"Skills_listtwo__11xMa","list":"Skills_list__FyGtr","top":"Skills_top__SoGUM","bottom":"Skills_bottom__hei+e"};